<template>
    <SignInForm />
</template>

<script setup lang="ts">
    import { usePublicStore } from "@/app/store/public/public-store";
    import SignInForm from "@views/public/sign-in/sign-in-form.vue";

    const publicStore = usePublicStore();
    publicStore.choseCountryPhone();
    
</script>

<!-- We need this tag for styles to work properly -->
<style lang="scss">
    // .empty-class {} 
</style>